<template>
  <card>
    <h4 slot="header" v-if="result" class="card-title text-center">{{result}}</h4>
    <form>
      <div class="row">
        <div class="col-md-4">
          <base-input type="text"
                    label="Name"
                    placeholder="Name"
                    v-model="user.name">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Email Address"
                    placeholder="Email Address"
                    v-model="user.emailAddress">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Password"
                    placeholder="Password"
                    v-model="user.password">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label class="control-label">
            Select Client
          </label>
          <br />
          <button v-for="(client, index) in clients" @click="selectClient(client)" type="button" :class="['btn', 'btn-sm', 'mr-1', 'mb-1', user.client && user.client === client._id ? 'btn-primary' : 'btn-secondary']">{{ client.name }}</button>
        </div>
      </div>
      <div class="text-center">
        <button v-if="!loading && user.name && user.emailAddress && user.password && user.password.length > 5 && user.client" type="submit" class="btn btn-info btn-fill float-right" @click.prevent="createUser">
          Create User
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
  import Card from 'src/components/Cards/Card.vue';

  export default {
    components: {
      Card
    },
    data () {
      return {
        loading: false,
        result: '',
        user: {
          name: '',
          emailAddress: '',
          password: '',
          client: '',
        },
        clients: '',
      }
    },
    async created() {
      await this.getClients();
    },
    methods: {
      async createUser () {
        try {
          this.loading = true
          const app = getApp()
          const functions = getFunctions(app, 'europe-west1')
          // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
          const createUser = httpsCallable(functions, 'createUser');
          await createUser(this.user)
          this.result = 'User Created Successfully'
        } catch (error) {
          console.log('error', error)
          this.result = 'Error: ' + error
        } finally {
          this.loading = false;
        }
      },
      async getClients () {
        try {
          this.loading = true
          const app = getApp()
          const functions = getFunctions(app, 'europe-west1')
          // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
          const getClients = httpsCallable(functions, 'getClients');
          const getClientsRes = await getClients();
          this.clients = getClientsRes && getClientsRes.data && getClientsRes.data.data
        } catch (error) {
          console.log('getClientsError', error)
          this.result = 'Error: ' + error
        } finally {
          this.loading = false;
        }
      },
      async selectClient(client) {
        try {
          console.log('client', client)
          this.user.client = client._id
        } catch (error) {
          console.log('selectClientError', error)
        }
      }
    }
  }

</script>
<style>

</style>
